<template>
  <v-alert prominent type="info" v-if="showSurvey()">
    <v-row align="center">
      <v-col class="grow">
        {{ $t("alerts.fill-survey") }}
      </v-col>
      <v-col class="shrink">
        <v-btn @click="goToSurvey()">
          <v-icon left>touch_app</v-icon>
          {{ $t("alerts.to-survey") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  name: "AlertForSurvey",
  data: () => ({
    surveyUrl:
      "https://docs.google.com/forms/d/1dc2pImfIQrQ4o7N55jotgKJLTegLWA8ZTE1X2VQLcLA/viewform?edit_requested=true",
    surveyKey: "satisfaction202302",
    surveyDeadline: "2023-02-15",
  }),
  props: ["userData"],
  methods: {
    async goToSurvey() {
      window.open(this.surveyUrl, "_blank");
      this.$emit("updateSurveyData", this.surveyKey);
    },
    showSurvey() {
      //show surver only for bfh, mok lat users untill 23.08.
      let show = false;
      const deadline = new Date(this.surveyDeadline);
      const today = new Date();

      //check deadline
      if (today < deadline) {
        //check service
        if (
          this.userData.aiderServices &&
          (this.userData.aiderServices.indexOf("bfh") > -1 ||
            this.userData.aiderServices.indexOf("neighborhood") > -1)
        ) {
          show = true;
          //show only once
          if (
            this.userData.surveys &&
            this.userData.surveys.satisfaction202302 &&
            this.userData.surveys.satisfaction202302.length > 1
          ) {
            show = false;
          }
        }
      }

      return show;
    },
  },
};
</script>

<style></style>
